import React from 'react'
import Grid from '@material-ui/core/Grid'
import SelectField from 'components/SelectField'
import Flag from 'react-world-flags'
import InputLabel from '@material-ui/core/InputLabel';
import RadioGroupField from 'components/RadioGroupField'

const ThemesConfig = [
  {
    value: "1",
    label: "Standardowy",
    themeColors: [
      {
        value: "#f18518",
        label: "#f18518",
        color: '#f18518'
      },
      {
        value: "#0075ff",
        label: "#0075ff",
        color: '#0075ff'
      },
      {
        value: "#213d9a",
        label: "#213d9a",
        color: '#213d9a'
      },
      {
        value: "#03dead",
        label: "#03dead",
        color: '#03dead'
      },
      {
        value: "#c00068",
        label: "#c00068",
        color: '#c00068'
      },
      {
        value: "#888888",
        label: "#888888",
        color: '#888888'
      }
    ]
  },
  {
    value: "2",
    label: "Elegancki",
    themeColors: [
      {
        value: "#00e2d5",
        label: "#00e2d5",
        color: '#00e2d5'
      },
      {
        value: "#7ec346",
        label: "#7ec346",
        color: '#7ec346'
      },
      {
        value: "#ddc818",
        label: "#ddc818",
        color: '#ddc818'
      },
      {
        value: "#b02c2c",
        label: "#b02c2c",
        color: '#b02c2c'
      },
      {
        value: "#de9cee",
        label: "#de9cee",
        color: '#de9cee'
      },
      {
        value: "#a9a9a9",
        label: "#a9a9a9",
        color: '#a9a9a9'
      }
    ]
  },
  {
    value: "3",
    label: "Łagodny",
    themeColors: [
      {
        value: "#bfa055",
        label: "#bfa055",
        color: '#bfa055'
      },
      {
        value: "#c46219",
        label: "#c46219",
        color: '#c46219'
      },
      {
        value: "#4dd2a4",
        label: "#4dd2a4",
        color: '#4dd2a4'
      },
      {
        value: "#a78eb6",
        label: "#a78eb6",
        color: '#a78eb6'
      },
      {
        value: "#afafaf",
        label: "#afafaf",
        color: '#afafaf'
      }
    ]
  },
  {
    value: "4",
    label: "Ostry",
    themeColors: [
      {
        value: "#ffe400",
        label: "#ffe400",
        color: '#ffe400'
      },
      {
        value: "#78ffce",
        label: "#78ffce",
        color: '#78ffce'
      },
      {
        value: "#a9abe2",
        label: "#a9abe2",
        color: '#a9abe2'
      },
      {
        value: "#dca4d9",
        label: "#dca4d9",
        color: '#dca4d9'
      },
      {
        value: "#d4d3db",
        label: "#d4d3db",
        color: '#d4d3db'
      },
      {
        value: "#ffa59c",
        label: "#ffa59c",
        color: '#ffa59c'
      }
    ]
  },
  {
    value: "5",
    label: "Stonowany",
    themeColors: [
      {
        value: "#ffe2a6",
        label: "#ffe2a6",
        color: '#ffe2a6'
      },
      {
        value: "#97ffcd",
        label: "#97ffcd",
        color: '#97ffcd'
      },
      {
        value: "#fbb9b4",
        label: "#fbb9b4",
        color: '#fbb9b4'
      }
    ]
  },
  {
    value: "6",
    label: "Odważny",
    themeColors: [
      {
        value: "#7d8e96",
        label: "#7d8e96",
        color: '#7d8e96'
      },
      {
        value: "#bfa055",
        label: "#bfa055",
        color: '#bfa055'
      },
      {
        value: "#946873",
        label: "#946873",
        color: '#946873'
      },
      {
        value: "#5e7655",
        label: "#5e7655",
        color: '#5e7655'
      },
      {
        value: "#444444",
        label: "#444444",
        color: '#444444'
      }
    ]
  }
]


const ThemeManagement = ({
  values
}) => {
  const choosenTemplateValue = values['template']
  const choosenTemplate = ThemesConfig.find(t => t.value === choosenTemplateValue)
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={2}>
        <InputLabel shrink>
            Język
        </InputLabel>
        <SelectField
          name="resumeLanguage"
          value="pl"
          options={[
            {
              value: "pl",
              label: <Flag code="PL" height="16" />
            },
            {
              value: "en",
              label: <Flag code="US" height="16" />
            }
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputLabel shrink>
            Szablon
        </InputLabel>

        <SelectField
          name="template"          
          menuStyle={{
            position: 'relative',
            top: -12.5,
          }}
          options={ThemesConfig}
        />
      </Grid>
      {choosenTemplate && choosenTemplate.themeColors &&
        <Grid item xs={12} sm={4}>
          <InputLabel shrink>
              Kolor szablonu
          </InputLabel>
          <RadioGroupField
            name="themeColor"
            options={choosenTemplate.themeColors}
          />
        </Grid>
      }
    </Grid>
  )
}

export default ThemeManagement
export {
  ThemesConfig
}
